import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";

import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Get_Null_School_Or_Country_Attendees } from "../../../Misc/api/Get_Null_School_Or_Country_Attendees";

function SXPAttendeesToSchoolTODO() {
  const { logout } = StaffuseAuth();

  const [SXPAttendees, setSXPAttendees] = useState([]);
  useEffect(() => {
    Get_Null_School_Or_Country_Attendees(
      "Registers_2025",
      "All",
      setSXPAttendees,
      100000,
      "All",
      "SXP",
      0,
      logout
    );
  }, []);

  function handleGoToSXPAttendeeSchoolAssigner(e) {
    e.preventDefault();
    window.open(`/Staff/AssignSXPAttendeeToSchool`, "_blank");
  }

  return (
    <>
      {SXPAttendees.length > 0 ? (
        <>
          <Container maxWidth="sm">
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              SXP Attendees ready to be assigned to a School:{" "}
              {SXPAttendees.length}
            </Box>
            <br></br>
            <button onClick={(e) => handleGoToSXPAttendeeSchoolAssigner(e)}>
              Go To
            </button>
            <br></br>
            <br></br>
          </Container>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default SXPAttendeesToSchoolTODO;
